<template>
  <Icon>
    <svg slot="svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs></defs>
      <g id="icons/check_no" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Bounding-Box" x="0" y="0" width="24" height="24"></rect>
        <circle id="Oval" fill="#D62839" cx="12" cy="12" r="10"></circle>
        <g id="cross" transform="translate(7.000000, 7.000000)" fill="#FFFFFF">
          <path d="M7.36461538,5.18461538 L9.54346154,3.00769231 C10.1446154,2.40769231 10.1446154,1.43076923 9.54346154,0.830769231 C8.94153846,0.226923077 7.96615385,0.226923077 7.36461538,0.830769231 L5.18615385,3.00769231 L3.00769231,0.830769231 C2.40653846,0.226923077 1.43115385,0.226923077 0.829230769,0.830769231 C0.228076923,1.43076923 0.228076923,2.40769231 0.829230769,3.00769231 L3.00769231,5.18461538 L0.829230769,7.36538462 C0.228076923,7.96538462 0.228076923,8.94230769 0.829230769,9.54230769 C1.43115385,10.1461538 2.40653846,10.1461538 3.00769231,9.54230769 L5.18615385,7.36538462 L7.36461538,9.54230769 C7.96615385,10.1461538 8.94153846,10.1461538 9.54346154,9.54230769 C10.1446154,8.94230769 10.1446154,7.96538462 9.54346154,7.36538462 L7.36461538,5.18461538" id="Shape"></path>
        </g>
      </g>
    </svg>
  </Icon>
</template>

<script>
import Icon from './icon';

export default {
  name: 'DsUnconfirmedIcon',
  components: {
    Icon
  }
};
</script>


// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-unconfirmed-icon.vue